import React, {useEffect} from "react";
import ObjectiveCascadeCard from "./ObjectiveCascadeCard";
import {CascadeItemContainer, CascadeMessage} from "../../styles/styles";
import useFilterUser from "../../../custom-hooks/useFilterUser";


const ObjectivesCascadeList = ({objectives, fromProject,setNumberOfObjectives,query}) => {

    const {
        getFullNameInverseNoWhiteSpace,
        getFullNameNoWhiteSpace,
        getQueryNoWhiteSpace,
    } = useFilterUser(objectives)

    useEffect(() => {
        if(!fromProject){
            setNumberOfObjectives(objectives.filter(objective =>
                objective.title.toLowerCase().includes(query.toLowerCase()) ||
                getFullNameNoWhiteSpace(objective.pilot).includes(getQueryNoWhiteSpace(query)) ||
                getFullNameInverseNoWhiteSpace(objective.pilot).includes(getQueryNoWhiteSpace(query)) ||
                (objective.linkedProjects.length > 0 ? objective.linkedProjects[0].name.toLowerCase().includes(query.toLowerCase()) : "")
            ).length)
        }
    }, [getFullNameInverseNoWhiteSpace, getFullNameNoWhiteSpace, getQueryNoWhiteSpace, objectives, query, setNumberOfObjectives,fromProject])


    return(
        <CascadeItemContainer>
            {
                objectives.length > 0 ?
                    !fromProject ? (objectives.filter(objective =>
                objective.title.toLowerCase().includes(query.toLowerCase()) ||
                getFullNameNoWhiteSpace(objective.pilot).includes(getQueryNoWhiteSpace(query)) ||
                getFullNameInverseNoWhiteSpace(objective.pilot).includes(getQueryNoWhiteSpace(query)) ||
                (objective.linkedProjects.length > 0 ? objective.linkedProjects[0].name.toLowerCase().includes(query.toLowerCase()) : "")
                ).map((o) => {
                        return <ObjectiveCascadeCard
                            objective={o}
                            key={o.id}
                            fromProject={fromProject}
                        />
                    })) : objectives.map((o) => {
                        return <ObjectiveCascadeCard
                            objective={o}
                            key={o.id}
                            fromProject={fromProject}
                        />}) :
                    <CascadeMessage> Il n'y a pas encore d'objectifs pour ce projet </CascadeMessage>
            }
        </CascadeItemContainer>
    )
}

export default ObjectivesCascadeList